export interface AppConfig {
  APP_NAME: string
  SPRING_BOOT?: string
  AI_INSIGHTS_WEBAPP_URL?: string
  PARIS_INSIGHTS_WEBAPP_URL?: string
  EMAIL_VERIFICATION_CONTINUEURL?: string
  FIREBASE_APIKEY?: string
  FIREBASE_AUTHDOMAIN?: string
  FIREBASE_DATABASEURL?: string
  FIREBASE_PROJECTID?: string
  FIREBASE_STORAGEBUCKET?: string
  FIREBASE_MESSAGINGSENDERID?: string
  FIREBASE_APPID?: string
}

const DEFAULTS: Partial<AppConfig> = {
  APP_NAME: 'Paris Insights'
}

let config: AppConfig | null = null

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json')
  if (!res.ok) {
    throw new Error(`Failed to load config: ${res.status} ${res.statusText}`)
  }
  const data = (await res.json()) as Partial<AppConfig>
  config = { ...DEFAULTS, ...data } as AppConfig
  return config
}

export function getConfig(): AppConfig {
  if (!config) {
    throw new Error('Config not loaded. Call loadConfig() first.')
  }
  return config
}

export function _setConfigForTesting(testConfig: AppConfig): void {
  config = testConfig
}
